var _regeneratorRuntime = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/regenerator");

var _toConsumableArray = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/home/ben/workspace/showhow.v2/src/main/app/node_modules/react-scripts-ts/node_modules/@babel/runtime/helpers/asyncToGenerator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//Export to Adobe After Effect's mgJSON format. It's poorly documented, but here's a minimal working example: https://github.com/JuanIrache/mgjson
var deduceHeaders = require('../utils/deduceHeaders');

var padStringNumber = require('../utils/padStringNumber');

var bigStr = require('../utils/bigStr');

var _require = require('../data/keys'),
    mgjsonMaxArrs = _require.mgjsonMaxArrs;

var breathe = require('../utils/breathe'); //After Effects can't read larger numbers


var largestMGJSONNum = 2147483648; //Build the style that After Effects needs for static text

function createDataOutlineChildText(_x, _x2, _x3) {
  return _createDataOutlineChildText.apply(this, arguments);
} //Build the style that After Effects needs for static numbers


function _createDataOutlineChildText() {
  _createDataOutlineChildText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(matchName, displayName, value) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (typeof value != 'string') value = value.toString();
            return _context2.abrupt("return", {
              objectType: 'dataStatic',
              displayName: displayName,
              dataType: {
                type: 'string',
                paddedStringProperties: {
                  maxLen: value.length,
                  maxDigitsInStrLength: value.length.toString().length,
                  eventMarkerB: false
                }
              },
              matchName: matchName,
              value: value
            });

          case 2:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _createDataOutlineChildText.apply(this, arguments);
}

function createDataOutlineChildNumber(_x4, _x5, _x6) {
  return _createDataOutlineChildNumber.apply(this, arguments);
} //Build the style that After Effects needs for dynamic values: numbers, arrays of numbers (axes) or strings (date)


function _createDataOutlineChildNumber() {
  _createDataOutlineChildNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(matchName, displayName, value) {
    var digitsInteger, digitsDecimal;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (isNaN(value)) value = 0;else value = +value;
            digitsInteger = Math.max(bigStr(Math.floor(value)).length, 0);
            digitsDecimal = Math.max(bigStr(value).replace(/^\d*\.?/, '').length, 0);
            return _context3.abrupt("return", {
              objectType: 'dataStatic',
              displayName: displayName,
              dataType: {
                type: 'number',
                numberStringProperties: {
                  pattern: {
                    isSigned: true,
                    digitsInteger: digitsInteger,
                    digitsDecimal: digitsDecimal
                  },
                  range: {
                    occuring: {
                      min: value,
                      max: value
                    },
                    legal: {
                      min: -largestMGJSONNum,
                      max: largestMGJSONNum
                    }
                  }
                }
              },
              matchName: matchName,
              value: value
            });

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _createDataOutlineChildNumber.apply(this, arguments);
}

function createDynamicDataOutline(_x7, _x8, _x9, _x10) {
  return _createDynamicDataOutline.apply(this, arguments);
} //Deduce the kind of structure we need, from the data


function _createDynamicDataOutline() {
  _createDynamicDataOutline = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(matchName, displayName, units, sample) {
    var _ref3,
        inn,
        out,
        part,
        stream,
        type,
        result,
        unitsArr,
        partialName,
        deducedHeaders,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _ref3 = _args4.length > 4 && _args4[4] !== undefined ? _args4[4] : {}, inn = _ref3.inn, out = _ref3.out;
            part = _args4.length > 5 ? _args4[5] : undefined;
            stream = _args4.length > 6 ? _args4[6] : undefined;
            _context4.next = 5;
            return getDataOutlineType(Array.isArray(sample) ? sample.slice(inn, out) : sample);

          case 5:
            type = _context4.sent;
            result = {
              objectType: 'dataDynamic',
              displayName: displayName,
              sampleSetID: matchName,
              dataType: {
                type: type
              },
              //We apply (linear) interpolation to numeric values only
              interpolation: type === 'paddedString' ? 'hold' : 'linear',
              hasExpectedFrequecyB: false,
              //Some values will be set afterwards
              sampleCount: null,
              matchName: matchName
            };

            if (type === 'numberString') {
              //Number saved as string (After Effects reasons)
              if (units && Array.isArray(sample)) {
                unitsArr = units.split(',');
                result.displayName += " [".concat(unitsArr[unitsArr.length - 1], "]");
              } else if (units) result.displayName += " [".concat(units, "]"); //Add fourCC to help AE identify streams


              if (stream && stream.length) result.displayName = stream + ': ' + result.displayName;

              if (Array.isArray(sample) && part) {
                //Try to create a different display name by specifying the part
                result.displayName += " part ".concat(part + 1);
              }

              result.dataType.numberStringProperties = {
                pattern: {
                  //Will be calculated later
                  digitsInteger: 0,
                  digitsDecimal: 0,
                  //Will use plus and minus signs always. Seems easier
                  isSigned: true
                },
                range: {
                  //We use the allowed extremes, will compare to actual data
                  occuring: {
                    min: largestMGJSONNum,
                    max: -largestMGJSONNum
                  },
                  //Legal values could potentially be modified per stream type (for example, latitude within -+85, longitude -+180... but what's the benefit?)
                  legal: {
                    min: -largestMGJSONNum,
                    max: largestMGJSONNum
                  }
                }
              };
            } else if (type === 'numberStringArray') {
              //Try to create a different display name, either by using the repeatheaders technique or specifying the part
              partialName = deduceHeaders({
                name: displayName,
                units: units
              }, {
                inn: inn,
                out: out
              });
              if (partialName != result.displayName) result.displayName = partialName;else if (part) result.displayName += " part ".concat(part + 1); //Array of numbers, for example axes of a sensor

              deducedHeaders = deduceHeaders({
                name: displayName,
                units: units
              }); //Fill gaps if present

              if (deducedHeaders.length != sample.length) {
                deducedHeaders = sample.map(function (s, ii) {
                  return deducedHeaders[ii] || deducedHeaders[ii - 1] || deducedHeaders[0] || 'undefined';
                });
              }

              deducedHeaders = deducedHeaders.slice(inn, out); //Add fourCC to help AE identify streams

              if (stream && stream.length) result.displayName = stream + ': ' + result.displayName;
              result.dataType.numberArrayProperties = {
                pattern: {
                  isSigned: true,
                  digitsInteger: 0,
                  digitsDecimal: 0
                },
                //Limited to 3 axes, we split the rest to additional streams
                arraySize: sample.slice(inn, out).length,
                //Set tentative headers for each array. much like the repeatHeaders option
                arrayDisplayNames: deducedHeaders,
                arrayRanges: {
                  ranges: sample.map(function (s) {
                    return {
                      occuring: {
                        min: largestMGJSONNum,
                        max: -largestMGJSONNum
                      },
                      legal: {
                        min: -largestMGJSONNum,
                        max: largestMGJSONNum
                      }
                    };
                  }).slice(inn, out)
                }
              };
            } else if (type === 'paddedString') {
              //Any other value is expressed as string
              if (units) result.displayName += "[".concat(units, "]"); //Add fourCC to help AE identify streams

              if (stream && stream.length) result.displayName = stream + ': ' + result.displayName;
              result.dataType.paddedStringProperties = {
                maxLen: 0,
                maxDigitsInStrLength: 0,
                eventMarkerB: false
              };
            }

            return _context4.abrupt("return", result);

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _createDynamicDataOutline.apply(this, arguments);
}

function getDataOutlineType(_x11) {
  return _getDataOutlineType.apply(this, arguments);
} //Returns the data as parts of an mgjson object


function _getDataOutlineType() {
  _getDataOutlineType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(value) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(typeof value === 'number' || Array.isArray(value) && value.length && value.length === 1)) {
              _context5.next = 4;
              break;
            }

            return _context5.abrupt("return", 'numberString');

          case 4:
            if (!(Array.isArray(value) && value.length && typeof value[0] === 'number')) {
              _context5.next = 8;
              break;
            }

            return _context5.abrupt("return", 'numberStringArray');

          case 8:
            return _context5.abrupt("return", 'paddedString');

          case 9:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getDataOutlineType.apply(this, arguments);
}

function convertSamples(_x12) {
  return _convertSamples.apply(this, arguments);
} //Converts the processed data to After Effects format


function _convertSamples() {
  _convertSamples = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(data) {
    var dataOutline, dataDynamicSamples, key, device, stream, streamName, units, getValidValue, validSample, inout, _loop, _ret;

    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            //Will hold the description of each stream
            dataOutline = []; //Holds the streams

            dataDynamicSamples = [];
            _context8.t0 = _regeneratorRuntime.keys(data);

          case 3:
            if ((_context8.t1 = _context8.t0()).done) {
              _context8.next = 40;
              break;
            }

            key = _context8.t1.value;

            if (!data[key].streams) {
              _context8.next = 38;
              break;
            }

            //Save a static entry with the device name
            device = key;
            if (data[key]['device name'] != null) device = data[key]['device name'];
            _context8.t2 = dataOutline;
            _context8.next = 11;
            return createDataOutlineChildText("DEVC".concat(key), 'Device name', device);

          case 11:
            _context8.t3 = _context8.sent;

            _context8.t2.push.call(_context8.t2, _context8.t3);

            _context8.t4 = _regeneratorRuntime.keys(data[key].streams);

          case 14:
            if ((_context8.t5 = _context8.t4()).done) {
              _context8.next = 38;
              break;
            }

            stream = _context8.t5.value;
            _context8.next = 18;
            return breathe();

          case 18:
            if (!(data[key].streams[stream].samples && data[key].streams[stream].samples.length)) {
              _context8.next = 36;
              break;
            }

            //Save the stream name for display
            streamName = stream;

            if (data[key].streams[stream].name != null) {
              streamName = data[key].streams[stream].name;

              if (data[key].streams[stream].subStreamName != null) {
                streamName += ' ' + data[key].streams[stream].subStreamName;
              }
            }

            units = void 0;
            if (data[key].streams[stream].units != null) units = data[key].streams[stream].units;

            getValidValue = /*#__PURE__*/function () {
              var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(arr, key) {
                var _iterator, _step, s;

                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _iterator = _createForOfIteratorHelper(arr);
                        _context6.prev = 1;

                        _iterator.s();

                      case 3:
                        if ((_step = _iterator.n()).done) {
                          _context6.next = 9;
                          break;
                        }

                        s = _step.value;

                        if (!(s[key] != null)) {
                          _context6.next = 7;
                          break;
                        }

                        return _context6.abrupt("return", s[key]);

                      case 7:
                        _context6.next = 3;
                        break;

                      case 9:
                        _context6.next = 14;
                        break;

                      case 11:
                        _context6.prev = 11;
                        _context6.t0 = _context6["catch"](1);

                        _iterator.e(_context6.t0);

                      case 14:
                        _context6.prev = 14;

                        _iterator.f();

                        return _context6.finish(14);

                      case 17:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6, null, [[1, 11, 14, 17]]);
              }));

              return function getValidValue(_x15, _x16) {
                return _ref4.apply(this, arguments);
              };
            }(); //Find a valid value to base the data structure on


            _context8.next = 26;
            return getValidValue(data[key].streams[stream].samples, 'value');

          case 26:
            validSample = _context8.sent;
            //Prepare iteration in case we need to loop over samples more than 3 items long, can be overriden from keys
            inout = void 0;
            if (Array.isArray(validSample)) inout = {
              inn: 0,
              out: mgjsonMaxArrs[stream.slice(0, 4)] || 3,
              total: validSample.length
            }; //Loop until all values are sorted. In most cases just once, decide break at the end

            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var part, sampleSetID, sampleSet, dataOutlineChild, type, setMaxMinPadStr, _loop2, i, _i, s, diff;

              return _regeneratorRuntime.wrap(function _loop$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      //Prepare sample set
                      part = inout ? inout.inn / (inout.out - inout.inn) : 0;
                      sampleSetID = "stream".concat(key + 'X' + stream + 'X' + (part ? part + 1 : ''));
                      sampleSet = {
                        sampleSetID: sampleSetID,
                        samples: []
                      }; //Create the stream structure

                      _context7.next = 5;
                      return createDynamicDataOutline(sampleSetID, streamName, units, validSample, inout, part, stream);

                    case 5:
                      dataOutlineChild = _context7.sent;
                      _context7.next = 8;
                      return getDataOutlineType(Array.isArray(validSample) ? validSample.slice(inout.inn, inout.out) : validSample);

                    case 8:
                      type = _context7.sent;

                      setMaxMinPadStr = function setMaxMinPadStr(val, outline) {
                        //Set found max lengths
                        outline.dataType.paddedStringProperties.maxLen = Math.max(val.toString().length, outline.dataType.paddedStringProperties.maxLen);
                        outline.dataType.paddedStringProperties.maxDigitsInStrLength = Math.max(val.length.toString().length, outline.dataType.paddedStringProperties.maxDigitsInStrLength);
                      }; //Loop all the samples


                      _loop2 = function _loop2(i) {
                        var s = data[key].streams[stream].samples[i];

                        var setMaxMinPadNum = function setMaxMinPadNum(val, pattern, range) {
                          //Update mins and maxes
                          range.occuring.min = Math.min(val, range.occuring.min);
                          range.occuring.max = Math.max(val, range.occuring.max); //And max left and right padding

                          pattern.digitsInteger = Math.max(bigStr(Math.floor(val)).length, pattern.digitsInteger);
                          pattern.digitsDecimal = Math.max(bigStr(val).replace(/^\d*\.?/, '').length, pattern.digitsDecimal);
                        }; //Back to data samples. Check that at least we have the valid values


                        if (s.value != null) {
                          var sample = {
                            time: new Date(s.cts)
                          };

                          if (type === 'numberString') {
                            //Extract the last lonely value of a fragmented array
                            var singleVal = s.value;
                            if (Array.isArray(s.value)) singleVal = s.value[inout.inn]; //Save numbers as strings

                            sample.value = bigStr(singleVal); //Update mins, maxes and padding

                            setMaxMinPadNum(singleVal, dataOutlineChild.dataType.numberStringProperties.pattern, dataOutlineChild.dataType.numberStringProperties.range);
                          } else if (type === 'numberStringArray') {
                            //Save arrays of numbers as arrays of strings
                            sample.value = [];
                            s.value.slice(inout.inn, inout.out).forEach(function (v, ii) {
                              sample.value[ii] = bigStr(v); //And update, mins, maxs and paddings

                              setMaxMinPadNum(v, dataOutlineChild.dataType.numberArrayProperties.pattern, dataOutlineChild.dataType.numberArrayProperties.arrayRanges.ranges[ii]);
                            });
                          } else if (type === 'paddedString') {
                            //Save anything else as (padded)string
                            //If dateStream, save date as string instead of dummy value
                            if (stream === 'dateStream') {
                              if (s.date != null) {
                                if (typeof s.date != 'object') s.date = new Date(s.date);

                                if (!isNaN(s.date)) {
                                  s.value = s.date.toISOString();
                                } else {
                                  s.value = new Date(s.date).toISOString();
                                }
                              } else s.value = 'undefined';
                            }

                            sample.value = {
                              length: s.value.length.toString(),
                              str: s.value
                            };
                            setMaxMinPadStr(s.value, dataOutlineChild);
                          } //Save sample


                          sampleSet.samples.push(sample);
                        }
                      };

                      for (i = 0; i < data[key].streams[stream].samples.length; i++) {
                        _loop2(i);
                      }

                      for (_i = 0; _i < sampleSet.samples.length; _i++) {
                        s = sampleSet.samples[_i];

                        if (type === 'numberString') {
                          //Apply max padding to every sample
                          s.value = padStringNumber(s.value, dataOutlineChild.dataType.numberStringProperties.pattern.digitsInteger, dataOutlineChild.dataType.numberStringProperties.pattern.digitsDecimal);
                        } else if (type === 'numberStringArray') {
                          //Apply max padding to every sample
                          s.value = s.value.map(function (v) {
                            return padStringNumber(v, dataOutlineChild.dataType.numberArrayProperties.pattern.digitsInteger, dataOutlineChild.dataType.numberArrayProperties.pattern.digitsDecimal);
                          });
                        } else if (type === 'paddedString') {
                          //Apply max padding to every sample
                          s.value.str = s.value.str.padEnd(dataOutlineChild.dataType.paddedStringProperties.maxLen, ' ');
                          s.value.length = s.value.length.padStart(dataOutlineChild.dataType.paddedStringProperties.maxDigitsInStrLength, '0');
                        }
                      } //Save total samples count


                      dataOutlineChild.sampleCount = sampleSet.samples.length; //Save stream

                      dataOutline.push(dataOutlineChild);
                      dataDynamicSamples.push(sampleSet); //Check if we reached the end or have to loop more fields in array value

                      if (!inout) {
                        _context7.next = 24;
                        break;
                      }

                      if (!(inout.out >= inout.total)) {
                        _context7.next = 19;
                        break;
                      }

                      return _context7.abrupt("return", "break");

                    case 19:
                      diff = inout.out - inout.inn;
                      inout.inn = inout.out;
                      inout.out += diff;
                      _context7.next = 25;
                      break;

                    case 24:
                      return _context7.abrupt("return", "break");

                    case 25:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _loop);
            });

          case 30:
            return _context8.delegateYield(_loop(), "t6", 31);

          case 31:
            _ret = _context8.t6;

            if (!(_ret === "break")) {
              _context8.next = 34;
              break;
            }

            return _context8.abrupt("break", 36);

          case 34:
            _context8.next = 30;
            break;

          case 36:
            _context8.next = 14;
            break;

          case 38:
            _context8.next = 3;
            break;

          case 40:
            return _context8.abrupt("return", {
              dataOutline: dataOutline,
              dataDynamicSamples: dataDynamicSamples
            });

          case 41:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7);
  }));
  return _convertSamples.apply(this, arguments);
}

module.exports = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
    var _ref$name, name, converted, result;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref$name = _ref.name, name = _ref$name === void 0 ? '' : _ref$name;

            if (!(data['frames/second'] == null)) {
              _context.next = 3;
              break;
            }

            throw new Error('After Effects needs frameRate');

          case 3:
            _context.next = 5;
            return convertSamples(data);

          case 5:
            converted = _context.sent;
            _context.t0 = {
              useTimecodeB: false,
              utcInfo: {
                precisionLength: 3,
                isGMT: true
              }
            };
            _context.next = 9;
            return createDataOutlineChildText('filename', 'File name', name);

          case 9:
            _context.t1 = _context.sent;
            _context.t2 = [_context.t1].concat(_toConsumableArray(converted.dataOutline));
            _context.t3 = converted.dataDynamicSamples;
            result = {
              version: 'MGJSON2.0.0',
              creator: 'https://github.com/JuanIrache/gopro-telemetry',
              dynamicSamplesPresentB: true,
              dynamicDataInfo: _context.t0,
              dataOutline: _context.t2,
              dataDynamicSamples: _context.t3
            };

            if (!(data['frames/second'] != null)) {
              _context.next = 19;
              break;
            }

            _context.t4 = result.dataOutline;
            _context.next = 17;
            return createDataOutlineChildNumber('framerate', 'Frame rate', data['frames/second']);

          case 17:
            _context.t5 = _context.sent;

            _context.t4.push.call(_context.t4, _context.t5);

          case 19:
            //Remove dynamic data if no samples
            if (!result.dataDynamicSamples.length) {
              delete result.dataDynamicSamples;
              delete result.dynamicDataInfo;
              result.dynamicSamplesPresentB = false;
            }

            return _context.abrupt("return", result);

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x13, _x14) {
    return _ref2.apply(this, arguments);
  };
}();